"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Navigation = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var auth_1 = require("firebase/auth");
var react_1 = require("react");
var react_redux_1 = require("react-redux");
var FaceTecSDK_1 = require("../../../core-sdk/FaceTecSDK.js/FaceTecSDK");
var AdditionalScreens_1 = require("../../../facetec/src/utilities/AdditionalScreens");
var DeveloperStatusMessages_1 = require("../../../facetec/src/utilities/DeveloperStatusMessages");
var SampleAppUtilities_1 = require("../../../facetec/src/utilities/SampleAppUtilities");
var ThemeHelpers_1 = require("../../../facetec/src/utilities/ThemeHelpers");
var Config_1 = require("../../Config");
var get__production_keys_1 = require("../../api/calls/sky_api/get_ production_keys");
var check_duplicates_1 = require("../../api/calls/user/authentication/check_duplicates");
var check_fraud_list_1 = require("../../api/calls/user/authentication/check_fraud_list");
var get_firebase_user_profile_1 = require("../../api/calls/user/get_firebase_user_profile");
var verification_copy_1 = require("../../constants/verification_copy");
var auth_2 = require("../../features/apis/auth");
var auth_3 = require("../../features/slices/auth");
var user_profile_1 = require("../../features/slices/user-profile");
var content_dialog_1 = require("../../features/thunks/content-dialog");
var facetec_1 = require("../../screens/facetec-auth/facetec");
var auth_persistence_1 = require("../../utils/auth-persistence");
var firebase_1 = require("../../utils/firebase");
var firebase_user_normalizer_1 = require("../../utils/firebase-user-normalizer");
var user_state_1 = require("../../utils/user-state");
var auth_modal_manager_1 = require("../auth-modal-manager");
var loan_application_modal_1 = require("../loan-application-modal");
var loan_disclaimer_modal_1 = require("../loan-disclaimer-modal");
var my_account_1 = require("../my-account");
var pep_pip_verification_modal_1 = require("../pep-pip-verification-modal");
var Navigation = function (_a) {
    var navigation = _a.navigation, branding = _a.branding, siteName = _a.siteName, authentication = _a.authentication, sections = _a.sections, siteConfig = _a.siteConfig;
    var dispatch = (0, react_redux_1.useDispatch)();
    var auth = (0, react_redux_1.useSelector)(function (state) { return state.auth; });
    var userProfile = (0, react_redux_1.useSelector)(function (state) { return state.userProfile.profile; });
    var facetecState = (0, react_redux_1.useSelector)(function (state) { return state.userProfile.facetec; });
    var login = (0, auth_2.useLoginMutation)()[0];
    var updateProfile = (0, auth_2.useUpdateProfileMutation)()[0];
    var _b = (0, react_1.useState)("#hero"), activeSection = _b[0], setActiveSection = _b[1];
    var _c = (0, react_1.useState)(false), isScrolling = _c[0], setIsScrolling = _c[1];
    var _d = (0, react_1.useState)(false), isAuthModalOpen = _d[0], setIsAuthModalOpen = _d[1];
    var _e = (0, react_1.useState)("login"), initialModal = _e[0], setInitialModal = _e[1];
    var _f = (0, react_1.useState)(false), isMobileMenuOpen = _f[0], setIsMobileMenuOpen = _f[1];
    var _g = (0, react_1.useState)(false), isUserMenuOpen = _g[0], setIsUserMenuOpen = _g[1];
    var _h = (0, react_1.useState)(false), isLoanApplicationOpen = _h[0], setIsLoanApplicationOpen = _h[1];
    var _j = (0, react_1.useState)(false), isLoanDisclaimerOpen = _j[0], setIsLoanDisclaimerOpen = _j[1];
    var _k = (0, react_1.useState)(false), isPepPipVerificationOpen = _k[0], setIsPepPipVerificationOpen = _k[1];
    var _l = (0, react_1.useState)(null), pepPipData = _l[0], setPepPipData = _l[1];
    var _m = (0, react_1.useState)(undefined), selectedLoanAmount = _m[0], setSelectedLoanAmount = _m[1];
    var _o = (0, react_1.useState)(undefined), currentLoan = _o[0], setCurrentLoan = _o[1];
    var _p = (0, react_1.useState)(false), isNewLoanFlow = _p[0], setIsNewLoanFlow = _p[1];
    // Facetec SDK state
    var _q = (0, react_1.useState)(false), sdkInitialized = _q[0], setSdkInitialized = _q[1];
    var _r = (0, react_1.useState)(0), initializationCount = _r[0], setInitializationCount = _r[1];
    // Track if we've already shown the session outdated alert - use ref to prevent React strict mode issues
    var hasShownSessionAlert = (0, react_1.useRef)(false);
    var autoLoginUidRef = (0, react_1.useRef)(null);
    // Filter navigation items to exclude links to hidden sections
    var visibleNavigationItems = navigation.items.filter(function (item) {
        // If the link doesn't start with #, it's not a section link (external/page link)
        if (!item.href.startsWith("#"))
            return true;
        // Get the section ID from the href (remove the #)
        var sectionId = item.href.substring(1);
        // Find the corresponding section
        var section = sections === null || sections === void 0 ? void 0 : sections.find(function (s) { return s.id === sectionId; });
        // If section not found or not hidden, show the nav item
        return !section || !section.hidden;
    });
    // Check if user is authenticated
    var isAuthenticated = !!auth.access_token;
    // Critical: Check if authenticated user has firebase_user_id
    // If not, they logged in before we added this field and need to re-authenticate
    (0, react_1.useEffect)(function () {
        if (isAuthenticated &&
            !auth.firebase_user_id &&
            !hasShownSessionAlert.current) {
            hasShownSessionAlert.current = true;
            // Clear credentials to force re-login
            dispatch((0, auth_3.clearCredentials)());
        }
        // Reset flag when user logs out
        if (!isAuthenticated) {
            hasShownSessionAlert.current = false;
        }
    }, [isAuthenticated, auth.firebase_user_id, dispatch]);
    var handleAnchorClick = function (e, href) {
        e.preventDefault();
        if (href.startsWith("#")) {
            var targetId = href.substring(1);
            var targetElement = document.getElementById(targetId);
            if (targetElement) {
                setIsScrolling(true);
                setActiveSection(href);
                var navHeight = 190; // Account for fixed nav height + topbar
                var targetPosition = targetElement.offsetTop - navHeight;
                window.scrollTo({
                    top: targetPosition,
                    behavior: "smooth",
                });
                // Re-enable scroll tracking after smooth scroll completes
                setTimeout(function () {
                    setIsScrolling(false);
                }, 1000);
            }
        }
        else {
            window.location.href = href;
        }
    };
    //Check if user if on blocked list or account duplicate
    var checkAccountStanding = function () { return __awaiter(void 0, void 0, void 0, function () {
        var fraudList, duplicateAccount;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!(auth.user_id && auth.facetecDBRef)) return [3 /*break*/, 4];
                    return [4 /*yield*/, (0, check_fraud_list_1.check_fraud_list)({
                            externalDatabaseRefID: auth.facetecDBRef,
                            groupName: "FraudUserSearchList",
                            minMatchLevel: 7,
                        })];
                case 1:
                    fraudList = _a.sent();
                    if (!fraudList.data.isOnFraudList) return [3 /*break*/, 2];
                    dispatch((0, auth_3.clearCredentials)());
                    dispatch((0, content_dialog_1.closeContentDialogThunk)());
                    dispatch((0, content_dialog_1.showContentDialogThunk)({
                        header: "Account Blocked",
                        content: ((0, jsx_runtime_1.jsxs)("div", { className: "p-4", children: [(0, jsx_runtime_1.jsx)("h2", { className: "text-lg font-bold mb-2", children: "Your account has been blocked" }), (0, jsx_runtime_1.jsx)("p", { className: "mb-4", children: "Please contact support for more information." })] })),
                        width: "full", // Full width for the My Account modal
                    }));
                    return [3 /*break*/, 4];
                case 2: return [4 /*yield*/, (0, check_duplicates_1.check_duplicates)({
                        externalDatabaseRefID: auth.facetecDBRef,
                    })];
                case 3:
                    duplicateAccount = _a.sent();
                    if (duplicateAccount.data.mainAccountEmail) {
                        dispatch((0, auth_3.clearCredentials)());
                        dispatch((0, content_dialog_1.closeContentDialogThunk)());
                        dispatch((0, content_dialog_1.showContentDialogThunk)({
                            header: "Account Duplicate",
                            content: ((0, jsx_runtime_1.jsxs)("div", { className: "p-4", children: [(0, jsx_runtime_1.jsx)("h2", { className: "text-lg font-bold mb-2", children: "Account Duplicate Detected" }), (0, jsx_runtime_1.jsxs)("p", { className: "mb-4", children: ["Your account has been flagged as a duplicate of an existing account associated with the email:", " ", (0, jsx_runtime_1.jsx)("strong", { children: duplicateAccount.data.mainAccountEmail }), "."] }), (0, jsx_runtime_1.jsx)("p", { className: "mb-4", children: "For security reasons, you have been logged out. Please contact support if you believe this is an error." }), (0, jsx_runtime_1.jsx)("button", { onClick: function () {
                                            // Open LiveChat widget
                                            if (window.LiveChatWidget) {
                                                window.LiveChatWidget.call("maximize");
                                            }
                                        }, className: "mt-4 bg-blue-500 text-white py-2 px-4 rounded hover:bg-blue-600 transition-colors", children: "Contact Support" })] })),
                            width: "full", // Full width for the My Account modal
                        }));
                    }
                    _a.label = 4;
                case 4: return [2 /*return*/];
            }
        });
    }); };
    // Track scroll position to update active section
    (0, react_1.useEffect)(function () {
        var handleScroll = function () {
            if (isScrolling)
                return; // Don't update during programmatic scrolling
            var scrollPosition = window.scrollY + 400; // Offset for navbar height - larger trigger area
            var sections = visibleNavigationItems
                .filter(function (item) { return item.href.startsWith("#"); })
                .map(function (item) { return item.href.substring(1); });
            for (var _i = 0, sections_1 = sections; _i < sections_1.length; _i++) {
                var sectionId = sections_1[_i];
                var element = document.getElementById(sectionId);
                if (element) {
                    var offsetTop = element.offsetTop;
                    var offsetBottom = offsetTop + element.offsetHeight;
                    if (scrollPosition >= offsetTop && scrollPosition < offsetBottom) {
                        setActiveSection("#".concat(sectionId));
                        break;
                    }
                }
            }
        };
        window.addEventListener("scroll", handleScroll);
        handleScroll(); // Check initial position
        return function () { return window.removeEventListener("scroll", handleScroll); };
    }, [visibleNavigationItems, isScrolling]);
    // Close user menu when clicking outside
    (0, react_1.useEffect)(function () {
        var handleClickOutside = function (event) {
            var target = event.target;
            if (isUserMenuOpen && !target.closest("[data-user-menu]")) {
                setIsUserMenuOpen(false);
            }
        };
        document.addEventListener("click", handleClickOutside);
        return function () { return document.removeEventListener("click", handleClickOutside); };
    }, [isUserMenuOpen]);
    // Listen for loan application modal trigger from other components
    (0, react_1.useEffect)(function () {
        var handleOpenLoanApplication = function (event) {
            var _a;
            // Extract loan amount from event detail if provided
            var customEvent = event;
            var loanData = customEvent === null || customEvent === void 0 ? void 0 : customEvent.detail;
            var isExistingLoanResume = Boolean((loanData === null || loanData === void 0 ? void 0 : loanData.uid) && (loanData === null || loanData === void 0 ? void 0 : loanData.status));
            var loanAmount = (_a = customEvent === null || customEvent === void 0 ? void 0 : customEvent.detail) === null || _a === void 0 ? void 0 : _a.loanAmount;
            if (loanAmount) {
                console.log("📥 Received loan amount from home screen:", loanAmount);
                setSelectedLoanAmount(loanAmount);
            }
            // If caller passed a loan object (edit flow), keep it for resume.
            if (isExistingLoanResume) {
                setCurrentLoan(loanData);
                setIsNewLoanFlow(false);
            }
            else {
                setCurrentLoan(undefined);
                setIsNewLoanFlow(true);
            }
            // Check if user is authenticated before opening loan application
            if (isAuthenticated) {
                // Existing loan resumes skip disclaimer/PEP because user already completed them.
                if (isExistingLoanResume) {
                    setIsLoanDisclaimerOpen(false);
                    setIsPepPipVerificationOpen(false);
                    setIsLoanApplicationOpen(true);
                }
                else {
                    // New loan application still follows disclaimer + PEP/PIP flow.
                    setIsLoanApplicationOpen(false);
                    setIsLoanDisclaimerOpen(true);
                }
            }
            else {
                // User not logged in - show login modal
                setInitialModal("login");
                setIsAuthModalOpen(true);
            }
        };
        window.addEventListener("openLoanApplication", handleOpenLoanApplication);
        return function () {
            return window.removeEventListener("openLoanApplication", handleOpenLoanApplication);
        };
    }, [isAuthenticated, userProfile]);
    // Initialize FaceTec SDK (site) once on mount (mirror admin logic)
    (0, react_1.useEffect)(function () {
        var initFaceTecProcesses = function () { return __awaiter(void 0, void 0, void 0, function () {
            var response, content, key, domains, expiryDate, keyText, error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, (0, get__production_keys_1.get_production_keys)({ is_web: true })];
                    case 1:
                        response = _a.sent();
                        content = response && response.status === 200 && response.data
                            ? response.data.content
                            : response && response.data.content
                                ? response.data.content
                                : null;
                        if (content) {
                            key = content.keys;
                            domains = key.domains;
                            expiryDate = key.expiryDate;
                            keyText = key.key;
                            Config_1.Config.ProductionKeyText = "{ \"domains\": \"".concat(domains, "\", \"expiryDate\": \"").concat(expiryDate, "\", \"key\": \"").concat(keyText, "\"}");
                            Config_1.Config.DeviceKeyIdentifier = content.key_identifier;
                            if (Config_1.Config.ProductionKeyText && Config_1.Config.DeviceKeyIdentifier) {
                                // Ensure SDK resource dirs are absolute so nested routes like /site/... resolve correctly
                                FaceTecSDK_1.FaceTecSDK.setResourceDirectory("/facetec/resources");
                                FaceTecSDK_1.FaceTecSDK.setImagesDirectory("/facetec/images");
                                Config_1.Config.initializeFromAutogeneratedConfig(FaceTecSDK_1.FaceTecSDK, function (initializedSuccessfully) {
                                    if (initializedSuccessfully)
                                        setInitializationCount(function (c) { return c + 1; });
                                    setSdkInitialized(initializedSuccessfully);
                                }, Config_1.Config.ProductionKeyText, Config_1.Config.DeviceKeyIdentifier);
                            }
                        }
                        return [3 /*break*/, 3];
                    case 2:
                        error_1 = _a.sent();
                        console.error("Error loading providers:", error_1);
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/];
                }
            });
        }); };
        initFaceTecProcesses();
    }, []);
    (0, react_1.useEffect)(function () {
        if (sdkInitialized) {
            Config_1.Config.didSucceed = sdkInitialized;
            onFaceTecSDKInitializationSuccess();
        }
        else if (initializationCount === 0 && !sdkInitialized) {
            Config_1.Config.didSucceed = sdkInitialized;
            onFaceTecSDKInitializationFailure();
        }
    }, [sdkInitialized]);
    (0, react_1.useEffect)(function () {
        if (auth.user_id && auth.facetecDBRef) {
            checkAccountStanding();
        }
    }, [auth.user_id, auth.facetecDBRef]);
    // ENFORCEMENT: Users without facetecDBRef must complete enrollment before using the app
    // This handles the case where user refreshes the page before completing enrollment
    (0, react_1.useEffect)(function () {
        // Only enforce if:
        // 1. User is logged in (has user_id)
        // 2. SDK is initialized
        // 3. User does NOT have a facetecDBRef (check auth state, profile, AND localStorage)
        // 4. User is NOT already biometrically authenticated (prevents re-showing after successful enrollment)
        var isUserLoggedIn = auth.user_id && auth.user_id.trim() !== "";
        // Check multiple sources for facetecDBRef:
        // 1. Redux auth state (set after login/signup)
        // 2. Redux profile state (set after Firebase profile fetch)
        // 3. localStorage (persisted from previous session)
        var localStorageFacetecRef = localStorage.getItem("facetecDBRef");
        var hasFacetecRef = !!auth.facetecDBRef ||
            !!(userProfile === null || userProfile === void 0 ? void 0 : userProfile.facetecDBRef) ||
            !!localStorageFacetecRef;
        var isBiometricAuthenticated = (facetecState === null || facetecState === void 0 ? void 0 : facetecState.authenticated) === true;
        if (isUserLoggedIn &&
            sdkInitialized &&
            !hasFacetecRef &&
            !isBiometricAuthenticated) {
            // Show FaceTec enrollment modal - not closable until enrollment completes
            dispatch((0, content_dialog_1.showContentDialogThunk)({
                header: verification_copy_1.FACIAL_RECOGNITION_REQUIRED,
                content: (0, jsx_runtime_1.jsx)(facetec_1.FaceTecApp, {}),
                width: "full",
                closable: false,
            }));
        }
        // Close the modal once user has facetecDBRef (enrollment complete)
        if (isUserLoggedIn && hasFacetecRef && isBiometricAuthenticated) {
            dispatch((0, content_dialog_1.closeContentDialogThunk)());
        }
    }, [
        auth.user_id,
        auth.facetecDBRef,
        userProfile === null || userProfile === void 0 ? void 0 : userProfile.facetecDBRef,
        sdkInitialized,
        facetecState === null || facetecState === void 0 ? void 0 : facetecState.authenticated,
        dispatch,
    ]);
    var handleSignInClick = function () {
        setInitialModal("login");
        setIsAuthModalOpen(true);
    };
    var handleSignUpClick = function () {
        setInitialModal("signup");
        setIsAuthModalOpen(true);
    };
    var handleAuthSuccess = (0, react_1.useCallback)(function (userData) { return __awaiter(void 0, void 0, void 0, function () {
        var firebaseUid, res, sanitizedProfile, facetecDBRef, err_1, rememberMe, firebaseUid, res, sanitizedProfile, err_2;
        var _a, _b, _c, _d, _e;
        return __generator(this, function (_f) {
            switch (_f.label) {
                case 0:
                    if (!(userData.firebase && userData.user && userData.letsTradeToken)) return [3 /*break*/, 5];
                    firebaseUid = ((_a = userData.firebase) === null || _a === void 0 ? void 0 : _a.localId) || ((_b = userData.user) === null || _b === void 0 ? void 0 : _b.firebaseId);
                    // Store firebase_user_id in localStorage immediately for FaceTec enrollment
                    if (firebaseUid) {
                        localStorage.setItem("firebase_user_id", firebaseUid);
                    }
                    dispatch((0, auth_3.setSkyCredentials)({
                        user: userData.user,
                        firebase: userData.firebase,
                        letsTradeToken: userData.letsTradeToken,
                    }));
                    // Persist Sky Lifestyle auth data
                    (0, auth_persistence_1.persistSkyAuthState)(userData.user, userData.firebase, userData.letsTradeToken);
                    // Seed FaceTec state for SampleApp consumption
                    (0, user_state_1.setAuthenticatedFacetec)(false, false);
                    if (!firebaseUid) return [3 /*break*/, 4];
                    _f.label = 1;
                case 1:
                    _f.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, (0, get_firebase_user_profile_1.get_firebase_user_profile)(firebaseUid)];
                case 2:
                    res = _f.sent();
                    if (res.success && ((_c = res === null || res === void 0 ? void 0 : res.content) === null || _c === void 0 ? void 0 : _c.sanitized)) {
                        sanitizedProfile = res.content.sanitized;
                        dispatch((0, user_profile_1.setFirebaseUserProfile)(sanitizedProfile));
                        facetecDBRef = sanitizedProfile === null || sanitizedProfile === void 0 ? void 0 : sanitizedProfile.facetecDBRef;
                        if (facetecDBRef) {
                            dispatch((0, auth_3.setFacetecDBRef)(facetecDBRef));
                            // Persist to localStorage for quick access on page refresh
                            localStorage.setItem("facetecDBRef", facetecDBRef);
                        }
                        (0, user_state_1.setAuthenticatedFacetec)(false, false);
                    }
                    return [3 /*break*/, 4];
                case 3:
                    err_1 = _f.sent();
                    console.error("Error fetching Firebase user profile:", err_1);
                    return [3 /*break*/, 4];
                case 4:
                    // Show FaceTec verification flow after login
                    dispatch((0, content_dialog_1.showContentDialogThunk)({
                        header: verification_copy_1.FACIAL_RECOGNITION,
                        content: (0, jsx_runtime_1.jsx)(facetec_1.FaceTecApp, {}),
                        width: "full",
                        closable: false,
                    }));
                    setIsAuthModalOpen(false);
                    return [3 /*break*/, 10];
                case 5:
                    // Regular login flow - handle standard login data
                    // Store firebase_user_id in localStorage immediately for FaceTec enrollment
                    // This ensures it's available even if Redux state hasn't updated yet
                    if (userData.firebase_user_id) {
                        localStorage.setItem("firebase_user_id", userData.firebase_user_id);
                    }
                    dispatch((0, auth_3.setCredentials)(userData));
                    rememberMe = userData.rememberMe || false;
                    (0, auth_persistence_1.persistAuthState)(userData, rememberMe);
                    // Seed FaceTec state for SampleApp consumption
                    (0, user_state_1.setAuthenticatedFacetec)(false, false);
                    firebaseUid = ((_d = firebase_1.auth.currentUser) === null || _d === void 0 ? void 0 : _d.uid) ||
                        userData.firebase_user_id ||
                        localStorage.getItem("firebase_user_id");
                    if (!firebaseUid) return [3 /*break*/, 9];
                    _f.label = 6;
                case 6:
                    _f.trys.push([6, 8, , 9]);
                    return [4 /*yield*/, (0, get_firebase_user_profile_1.get_firebase_user_profile)(firebaseUid)];
                case 7:
                    res = _f.sent();
                    if (res.success && ((_e = res === null || res === void 0 ? void 0 : res.content) === null || _e === void 0 ? void 0 : _e.sanitized)) {
                        sanitizedProfile = res.content.sanitized;
                        dispatch((0, user_profile_1.setFirebaseUserProfile)(sanitizedProfile));
                        if (sanitizedProfile === null || sanitizedProfile === void 0 ? void 0 : sanitizedProfile.facetecDBRef) {
                            dispatch((0, auth_3.setFacetecDBRef)(sanitizedProfile.facetecDBRef));
                            localStorage.setItem("facetecDBRef", sanitizedProfile.facetecDBRef);
                        }
                        (0, user_state_1.setAuthenticatedFacetec)(false, false);
                    }
                    return [3 /*break*/, 9];
                case 8:
                    err_2 = _f.sent();
                    console.error("Error fetching Firebase user profile:", err_2);
                    return [3 /*break*/, 9];
                case 9:
                    // Show FaceTec verification flow after login
                    dispatch((0, content_dialog_1.showContentDialogThunk)({
                        header: verification_copy_1.FACIAL_RECOGNITION,
                        content: (0, jsx_runtime_1.jsx)(facetec_1.FaceTecApp, {}),
                        width: "full",
                        closable: false,
                    }));
                    setIsAuthModalOpen(false);
                    _f.label = 10;
                case 10: return [2 /*return*/];
            }
        });
    }); }, [dispatch, setIsAuthModalOpen]);
    (0, react_1.useEffect)(function () {
        if (typeof window === "undefined") {
            return;
        }
        var unsubscribe = (0, auth_1.onAuthStateChanged)(firebase_1.auth, function (firebaseUser) { return __awaiter(void 0, void 0, void 0, function () {
            var manualLoginPending, uid, idToken, response, autoLoginError_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!firebaseUser) {
                            autoLoginUidRef.current = null;
                            return [2 /*return*/];
                        }
                        manualLoginPending = typeof window !== "undefined" &&
                            sessionStorage.getItem("manual_login_pending") === "true";
                        if (manualLoginPending) {
                            return [2 /*return*/];
                        }
                        uid = firebaseUser.uid;
                        if ((auth.access_token && auth.firebase_user_id === uid) ||
                            autoLoginUidRef.current === uid) {
                            return [2 /*return*/];
                        }
                        autoLoginUidRef.current = uid;
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 5, , 6]);
                        return [4 /*yield*/, (0, firebase_user_normalizer_1.normalizeFirestoreHomeAddress)(uid)];
                    case 2:
                        _a.sent();
                        return [4 /*yield*/, firebaseUser.getIdToken()];
                    case 3:
                        idToken = _a.sent();
                        return [4 /*yield*/, login({ idToken: idToken }).unwrap()];
                    case 4:
                        response = _a.sent();
                        if ((response === null || response === void 0 ? void 0 : response.success) && response.content) {
                            localStorage.setItem("firebase_user_id", uid);
                            handleAuthSuccess(__assign(__assign({}, response.content), { firebase_user_id: uid, rememberMe: true }));
                        }
                        else {
                            console.warn("Firebase auto-login failed:", response === null || response === void 0 ? void 0 : response.message);
                            autoLoginUidRef.current = null;
                        }
                        return [3 /*break*/, 6];
                    case 5:
                        autoLoginError_1 = _a.sent();
                        console.error("Auto-login via Firebase failed:", autoLoginError_1);
                        autoLoginUidRef.current = null;
                        return [3 /*break*/, 6];
                    case 6: return [2 /*return*/];
                }
            });
        }); });
        return function () { return unsubscribe(); };
    }, [auth.access_token, auth.firebase_user_id, handleAuthSuccess, login]);
    var handleLogout = function () { return __awaiter(void 0, void 0, void 0, function () {
        var error_2;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 3, , 4]);
                    // 1. Sign out of Firebase first (clears Firebase auth session)
                    return [4 /*yield*/, (0, auth_1.signOut)(firebase_1.auth)];
                case 1:
                    // 1. Sign out of Firebase first (clears Firebase auth session)
                    _a.sent();
                    // 2. Clear auto-login reference
                    autoLoginUidRef.current = null;
                    // 3. Clear the redux store
                    dispatch((0, auth_3.clearCredentials)());
                    dispatch((0, user_profile_1.clearFirebaseUserProfile)());
                    dispatch((0, user_profile_1.clearFaceTecActions)());
                    // 4. Close FaceTec dialog if open
                    dispatch((0, content_dialog_1.closeContentDialogThunk)());
                    // 5. Clear biometric authentication state
                    (0, user_state_1.setAuthenticatedFacetec)(false, false);
                    // 6. Clear ALL auth-related localStorage/sessionStorage
                    // This includes: firebase_token, firebase_refresh_token, lets_trade_token,
                    // sky_user_data, access_token, user_data, refresh_token
                    (0, auth_persistence_1.clearPersistedAuthState)();
                    // Also clear redux-persist and firebase_user_id marker
                    localStorage.removeItem("persist:root");
                    localStorage.removeItem("firebase_user_id");
                    // 7. Close user menu
                    setIsUserMenuOpen(false);
                    // 8. Wait for Firebase signOut to propagate before reloading
                    // This prevents onAuthStateChanged from seeing stale auth state
                    return [4 /*yield*/, new Promise(function (r) { return setTimeout(r, 500); })];
                case 2:
                    // 8. Wait for Firebase signOut to propagate before reloading
                    // This prevents onAuthStateChanged from seeing stale auth state
                    _a.sent();
                    // 9. Force page refresh to clear FaceTec SDK session and all state
                    window.location.reload();
                    return [3 /*break*/, 4];
                case 3:
                    error_2 = _a.sent();
                    console.error("Logout error:", error_2);
                    // Still reload even if Firebase signOut fails
                    window.location.reload();
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
    var handleMyAccount = function () {
        setIsUserMenuOpen(false);
        dispatch((0, content_dialog_1.showContentDialogThunk)({
            header: "My Account",
            content: ((0, jsx_runtime_1.jsx)(my_account_1.MyAccount, { branding: branding, siteName: siteName, siteConfig: siteConfig })),
            width: "normal", // My Account uses standard width
        }));
    };
    var handleApplyForLoan = function () {
        setIsUserMenuOpen(false);
        setCurrentLoan(undefined);
        setIsNewLoanFlow(true);
        // Always show disclaimer and PEP/PIP modals for each new loan application
        setIsLoanDisclaimerOpen(true);
    };
    var handleCloseAllLoanModals = function () {
        setIsLoanDisclaimerOpen(false);
        setIsPepPipVerificationOpen(false);
        setIsLoanApplicationOpen(false);
        setPepPipData(null);
        setCurrentLoan(undefined);
        setIsNewLoanFlow(false);
    };
    // Extract loan calculator configuration from sections
    var loanCalculatorSection = sections === null || sections === void 0 ? void 0 : sections.find(function (section) { return section.type === "loan-calculator"; });
    var loanConfig = (loanCalculatorSection === null || loanCalculatorSection === void 0 ? void 0 : loanCalculatorSection.config) || {
        minAmount: 5000,
        maxAmount: 150000,
        defaultAmount: 50000,
    };
    return ((0, jsx_runtime_1.jsxs)("nav", { className: "fixed top-[102px] md:top-[55px] left-0 right-0 z-50 bg-white shadow-lg", children: [(0, jsx_runtime_1.jsxs)("div", { className: "max-w-7xl mx-auto px-6", children: [(0, jsx_runtime_1.jsxs)("div", { className: "flex items-center justify-between h-16 md:h-[160px]", children: [(0, jsx_runtime_1.jsxs)("div", { className: "flex flex-col items-start", children: [(0, jsx_runtime_1.jsx)("div", { className: "flex-shrink-0 mb-1", children: (0, jsx_runtime_1.jsx)("img", { src: branding.logo, alt: "Logo", className: "h-16 w-auto", onError: function (e) {
                                                e.currentTarget.style.display = "none";
                                            } }) }), (0, jsx_runtime_1.jsx)("div", { className: "md:block hidden", style: { display: window.innerWidth >= 768 ? "block" : "none" }, children: (0, jsx_runtime_1.jsx)("div", { className: "flex items-baseline space-x-6 mt-4", style: { display: "flex" }, children: visibleNavigationItems.map(function (item, index) {
                                                var isActive = activeSection === item.href;
                                                return ((0, jsx_runtime_1.jsx)("a", { href: item.href, onClick: function (e) { return handleAnchorClick(e, item.href); }, className: "px-2 py-1 text-xs font-medium transition-colors cursor-pointer ".concat(isActive
                                                        ? "border-b-2"
                                                        : "text-gray-700 hover:text-gray-900"), style: isActive
                                                        ? {
                                                            color: branding.primaryColor,
                                                            borderColor: branding.primaryColor,
                                                        }
                                                        : {}, children: item.label }, index));
                                            }) }) })] }), (0, jsx_runtime_1.jsx)("div", { className: "hidden md:flex items-center space-x-4", children: isAuthenticated ? (
                                // Authenticated state - show user menu
                                (0, jsx_runtime_1.jsxs)("div", { className: "relative", "data-user-menu": true, children: [(0, jsx_runtime_1.jsxs)("button", { onClick: function () { return setIsUserMenuOpen(!isUserMenuOpen); }, className: "flex items-center space-x-2 text-gray-700 hover:text-gray-900 px-4 py-2 rounded-md transition-colors", children: [(0, jsx_runtime_1.jsx)("div", { className: "w-8 h-8 rounded-full flex items-center justify-center text-white text-sm font-medium", style: { backgroundColor: branding.primaryColor }, children: auth.name ? auth.name.charAt(0).toUpperCase() : "U" }), (0, jsx_runtime_1.jsxs)("span", { className: "text-sm font-medium", children: [auth.name, " ", auth.surname] }), (0, jsx_runtime_1.jsx)("svg", { className: "w-4 h-4", fill: "none", stroke: "currentColor", viewBox: "0 0 24 24", children: (0, jsx_runtime_1.jsx)("path", { strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: 2, d: "M19 9l-7 7-7-7" }) })] }), isUserMenuOpen && ((0, jsx_runtime_1.jsx)("div", { className: "absolute right-0 mt-2 w-48 bg-white rounded-md shadow-lg ring-1 ring-black ring-opacity-5 z-50", children: (0, jsx_runtime_1.jsxs)("div", { className: "py-1", children: [(0, jsx_runtime_1.jsx)("div", { className: "px-4 py-2 text-xs text-gray-500 border-b border-gray-100", children: auth.email }), (0, jsx_runtime_1.jsx)("button", { onClick: handleMyAccount, className: "block w-full text-left px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 transition-colors", children: (0, jsx_runtime_1.jsxs)("div", { className: "flex items-center space-x-2", children: [(0, jsx_runtime_1.jsx)("svg", { className: "w-4 h-4", fill: "currentColor", viewBox: "0 0 20 20", children: (0, jsx_runtime_1.jsx)("path", { fillRule: "evenodd", d: "M10 9a3 3 0 100-6 3 3 0 000 6zm-7 9a7 7 0 1114 0H3z", clipRule: "evenodd" }) }), (0, jsx_runtime_1.jsx)("span", { children: "My Account" })] }) }), (0, jsx_runtime_1.jsx)("button", { onClick: handleApplyForLoan, className: "block w-full text-left px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 transition-colors", children: (0, jsx_runtime_1.jsxs)("div", { className: "flex items-center space-x-2", children: [(0, jsx_runtime_1.jsxs)("svg", { className: "w-4 h-4", fill: "currentColor", viewBox: "0 0 20 20", children: [(0, jsx_runtime_1.jsx)("path", { d: "M8.433 7.418c.155-.103.346-.196.567-.267v1.698a2.305 2.305 0 01-.567-.267C8.07 8.34 8 8.114 8 8c0-.114.07-.34.433-.582zM11 12.849v-1.698c.22.071.412.164.567.267.364.243.433.468.433.582 0 .114-.07.34-.433.582a2.305 2.305 0 01-.567.267z" }), (0, jsx_runtime_1.jsx)("path", { fillRule: "evenodd", d: "M10 18a8 8 0 100-16 8 8 0 000 16zm1-13a1 1 0 10-2 0v.092a4.535 4.535 0 00-1.676.662C6.602 6.234 6 7.009 6 8c0 .99.602 1.765 1.324 2.246.48.32 1.054.545 1.676.662v1.941c-.391-.127-.68-.317-.843-.504a1 1 0 10-1.51 1.31c.562.649 1.413 1.076 2.353 1.253V15a1 1 0 102 0v-.092a4.535 4.535 0 001.676-.662C13.398 13.766 14 12.991 14 12c0-.99-.602-1.765-1.324-2.246A4.535 4.535 0 0011 9.092V7.151c.391.127.68.317.843.504a1 1 0 101.511-1.31c-.563-.649-1.413-1.076-2.354-1.253V5z", clipRule: "evenodd" })] }), (0, jsx_runtime_1.jsx)("span", { children: "Apply for Loan" })] }) }), (0, jsx_runtime_1.jsx)("button", { onClick: handleLogout, className: "block w-full text-left px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 transition-colors", children: (0, jsx_runtime_1.jsxs)("div", { className: "flex items-center space-x-2", children: [(0, jsx_runtime_1.jsx)("svg", { className: "w-4 h-4", fill: "none", stroke: "currentColor", viewBox: "0 0 24 24", children: (0, jsx_runtime_1.jsx)("path", { strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: 2, d: "M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h4a3 3 0 013 3v1" }) }), (0, jsx_runtime_1.jsx)("span", { children: "Logout" })] }) })] }) }))] })) : (
                                // Unauthenticated state - show sign in/up buttons
                                (0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)("button", { onClick: handleSignInClick, className: "text-white px-6 py-2 rounded text-sm font-medium transition-colors hover:opacity-90", style: { backgroundColor: branding.primaryColor }, children: "Sign In" }), (0, jsx_runtime_1.jsxs)("button", { onClick: handleSignUpClick, className: "border-2 px-6 py-2 rounded text-sm font-medium transition-colors flex items-center space-x-2 hover:opacity-10", style: {
                                                borderColor: branding.primaryColor,
                                                color: branding.primaryColor,
                                            }, onMouseEnter: function (e) {
                                                e.currentTarget.style.backgroundColor =
                                                    branding.primaryColor;
                                                e.currentTarget.style.color = "white";
                                            }, onMouseLeave: function (e) {
                                                e.currentTarget.style.backgroundColor = "transparent";
                                                e.currentTarget.style.color = branding.primaryColor;
                                            }, children: [(0, jsx_runtime_1.jsx)("svg", { className: "w-4 h-4", fill: "currentColor", viewBox: "0 0 20 20", children: (0, jsx_runtime_1.jsx)("path", { fillRule: "evenodd", d: "M10 9a3 3 0 100-6 3 3 0 000 6zm-7 9a7 7 0 1114 0H3z", clipRule: "evenodd" }) }), (0, jsx_runtime_1.jsx)("span", { children: "SIGN UP" })] })] })) }), (0, jsx_runtime_1.jsx)("div", { className: "md:hidden", children: (0, jsx_runtime_1.jsx)("button", { onClick: function () { return setIsMobileMenuOpen(!isMobileMenuOpen); }, className: "p-2 text-gray-700 hover:text-gray-900", children: isMobileMenuOpen ? ((0, jsx_runtime_1.jsx)("svg", { className: "h-6 w-6", fill: "none", viewBox: "0 0 24 24", stroke: "currentColor", children: (0, jsx_runtime_1.jsx)("path", { strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: 2, d: "M6 18L18 6M6 6l12 12" }) })) : ((0, jsx_runtime_1.jsx)("svg", { className: "h-6 w-6", fill: "none", viewBox: "0 0 24 24", stroke: "currentColor", children: (0, jsx_runtime_1.jsx)("path", { strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: 2, d: "M4 6h16M4 12h16M4 18h16" }) })) }) })] }), isMobileMenuOpen && ((0, jsx_runtime_1.jsx)("div", { className: "md:hidden bg-white border-t border-gray-200", children: (0, jsx_runtime_1.jsxs)("div", { className: "px-6 py-4 space-y-4", children: [visibleNavigationItems.map(function (item, index) {
                                    var isActive = activeSection === item.href;
                                    return ((0, jsx_runtime_1.jsx)("a", { href: item.href, onClick: function (e) {
                                            handleAnchorClick(e, item.href);
                                            setIsMobileMenuOpen(false); // Close mobile menu after click
                                        }, className: "block px-3 py-2 text-base font-medium transition-colors ".concat(isActive
                                            ? "border-l-4"
                                            : "text-gray-700 hover:text-gray-900"), style: isActive
                                            ? {
                                                color: branding.primaryColor,
                                                borderColor: branding.primaryColor,
                                            }
                                            : {}, children: item.label }, index));
                                }), (0, jsx_runtime_1.jsx)("div", { className: "pt-4 border-t border-gray-200 space-y-3", children: isAuthenticated ? (
                                    // Authenticated mobile menu
                                    (0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsxs)("div", { className: "flex items-center space-x-3 p-3 bg-gray-50 rounded-md", children: [(0, jsx_runtime_1.jsx)("div", { className: "w-10 h-10 rounded-full flex items-center justify-center text-white font-medium", style: { backgroundColor: branding.primaryColor }, children: auth.name ? auth.name.charAt(0).toUpperCase() : "U" }), (0, jsx_runtime_1.jsxs)("div", { className: "flex-1", children: [(0, jsx_runtime_1.jsx)("div", { className: "text-sm font-medium text-gray-900", children: auth.email }), (0, jsx_runtime_1.jsxs)("div", { className: "text-xs text-gray-500", children: [auth.name, " ", auth.surname] })] })] }), (0, jsx_runtime_1.jsxs)("button", { onClick: function () {
                                                    handleMyAccount();
                                                    setIsMobileMenuOpen(false);
                                                }, className: "w-full flex items-center justify-center space-x-2 px-6 py-3 rounded text-sm font-medium transition-colors border-2", style: {
                                                    borderColor: branding.primaryColor,
                                                    color: branding.primaryColor,
                                                }, children: [(0, jsx_runtime_1.jsx)("svg", { className: "w-4 h-4", fill: "currentColor", viewBox: "0 0 20 20", children: (0, jsx_runtime_1.jsx)("path", { fillRule: "evenodd", d: "M10 9a3 3 0 100-6 3 3 0 000 6zm-7 9a7 7 0 1114 0H3z", clipRule: "evenodd" }) }), (0, jsx_runtime_1.jsx)("span", { children: "My Account" })] }), (0, jsx_runtime_1.jsxs)("button", { onClick: function () {
                                                    handleLogout();
                                                    setIsMobileMenuOpen(false);
                                                }, className: "w-full flex items-center justify-center space-x-2 px-6 py-3 rounded text-sm font-medium transition-colors bg-gray-100 text-gray-700 hover:bg-gray-200", children: [(0, jsx_runtime_1.jsx)("svg", { className: "w-4 h-4", fill: "none", stroke: "currentColor", viewBox: "0 0 24 24", children: (0, jsx_runtime_1.jsx)("path", { strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: 2, d: "M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h4a3 3 0 013 3v1" }) }), (0, jsx_runtime_1.jsx)("span", { children: "Logout" })] })] })) : (
                                    // Unauthenticated mobile menu
                                    (0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)("button", { onClick: function () {
                                                    handleSignInClick();
                                                    setIsMobileMenuOpen(false);
                                                }, className: "w-full text-white px-6 py-3 rounded text-sm font-medium transition-colors hover:opacity-90", style: { backgroundColor: branding.primaryColor }, children: "Sign In" }), (0, jsx_runtime_1.jsxs)("button", { onClick: function () {
                                                    handleSignUpClick();
                                                    setIsMobileMenuOpen(false);
                                                }, className: "w-full border-2 px-6 py-3 rounded text-sm font-medium transition-colors flex items-center justify-center space-x-2 hover:opacity-90", style: {
                                                    borderColor: branding.primaryColor,
                                                    color: branding.primaryColor,
                                                }, children: [(0, jsx_runtime_1.jsx)("svg", { className: "w-4 h-4", fill: "currentColor", viewBox: "0 0 20 20", children: (0, jsx_runtime_1.jsx)("path", { fillRule: "evenodd", d: "M10 9a3 3 0 100-6 3 3 0 000 6zm-7 9a7 7 0 1114 0H3z", clipRule: "evenodd" }) }), (0, jsx_runtime_1.jsx)("span", { children: "SIGN UP" })] })] })) })] }) }))] }), (0, jsx_runtime_1.jsx)(auth_modal_manager_1.AuthModalManager, { isOpen: isAuthModalOpen, onClose: function () { return setIsAuthModalOpen(false); }, branding: branding, siteName: siteName, authentication: authentication, initialModal: initialModal, onAuthSuccess: handleAuthSuccess, siteConfig: siteConfig }), (0, jsx_runtime_1.jsx)(loan_disclaimer_modal_1.LoanDisclaimerModal, { isOpen: isLoanDisclaimerOpen, onClose: handleCloseAllLoanModals, onProceed: function () {
                    setIsLoanDisclaimerOpen(false);
                    setIsPepPipVerificationOpen(true);
                }, primaryColor: branding.primaryColor }), (0, jsx_runtime_1.jsx)(pep_pip_verification_modal_1.PepPipVerificationModal, { isOpen: isPepPipVerificationOpen, onClose: handleCloseAllLoanModals, onProceed: function (data) { return __awaiter(void 0, void 0, void 0, function () {
                    var updatedProfile, error_3;
                    return __generator(this, function (_a) {
                        switch (_a.label) {
                            case 0:
                                setPepPipData(data);
                                setIsPepPipVerificationOpen(false);
                                setIsLoanApplicationOpen(true);
                                _a.label = 1;
                            case 1:
                                _a.trys.push([1, 5, , 6]);
                                return [4 /*yield*/, updateProfile({ pep_completed: true }).unwrap()];
                            case 2:
                                _a.sent();
                                if (!auth.firebase_user_id) return [3 /*break*/, 4];
                                return [4 /*yield*/, (0, get_firebase_user_profile_1.get_firebase_user_profile)(auth.firebase_user_id)];
                            case 3:
                                updatedProfile = _a.sent();
                                if (updatedProfile.success && updatedProfile.content) {
                                    dispatch((0, user_profile_1.setFirebaseUserProfile)(updatedProfile.content.sanitized));
                                }
                                _a.label = 4;
                            case 4: return [3 /*break*/, 6];
                            case 5:
                                error_3 = _a.sent();
                                console.error("Failed to update PEP/PIP completion status:", error_3);
                                return [3 /*break*/, 6];
                            case 6: return [2 /*return*/];
                        }
                    });
                }); }, primaryColor: branding.primaryColor }), (0, jsx_runtime_1.jsx)(loan_application_modal_1.LoanApplicationModal, { isOpen: isLoanApplicationOpen, onClose: handleCloseAllLoanModals, branding: branding, siteName: siteName, siteConfig: siteConfig, loanConfig: loanConfig, initialAmount: selectedLoanAmount, currentLoan: currentLoan, forceNewApplication: isNewLoanFlow })] }));
};
exports.Navigation = Navigation;
// Facetec SDK Initialization Handlers
function onFaceTecSDKInitializationSuccess() {
    SampleAppUtilities_1.SampleAppUtilities.enableControlButtons();
    // Ensure resource/image directories are absolute so nested routes resolve correctly
    FaceTecSDK_1.FaceTecSDK.setResourceDirectory("/facetec/resources");
    FaceTecSDK_1.FaceTecSDK.setImagesDirectory("/facetec/images");
    ThemeHelpers_1.ThemeHelpers.setAppTheme(ThemeHelpers_1.ThemeHelpers.getCurrentTheme());
    SampleAppUtilities_1.SampleAppUtilities.setVocalGuidanceSoundFiles();
    SampleAppUtilities_1.SampleAppUtilities.setOCRLocalization();
    if (document.getElementById("controls") !== null) {
        AdditionalScreens_1.AdditionalScreens.setServerUpgradeStyling(document.getElementById("controls"), exitAdditionalScreen);
    }
    DeveloperStatusMessages_1.DeveloperStatusMessages.logInitializeResult();
}
function onFaceTecSDKInitializationFailure() {
    DeveloperStatusMessages_1.DeveloperStatusMessages.logInitializeResult();
}
function exitAdditionalScreen() {
    AdditionalScreens_1.AdditionalScreens.exitAdditionalScreen(SampleAppUtilities_1.SampleAppUtilities.showMainUI);
}
